import {TFunction} from 'i18next';
import {boolean, object, SchemaOf, string} from 'yup';
import {EnvironmentType} from '../../../../shared/model/EnvironmentType.model';
import {
  envFormInitValues,
  envFormValidationSchema,
  EnvironmentFormFields,
  EnvironmentsFormFields
} from '../Environment.form.model';
import {Environment, EnvironmentAttributes} from '../Environment.model';
import {findEnvironmentByType} from '../EnvironmentUtils';

export type WoocommerceEnvironmentAttributes = EnvironmentAttributes & {
  callbackUrl: string;
  externalStatusPageEnabled: boolean;
};

export type WoocommerceEnvironmentFormFields = EnvironmentFormFields & {
  callbackUrl: string;
  externalStatusPageEnabled: boolean;
};

const woocommerceEnvFormInitValues = (
  environment: Environment<WoocommerceEnvironmentAttributes>
): WoocommerceEnvironmentFormFields => ({
  ...envFormInitValues(environment),
  externalStatusPageEnabled: false,
  callbackUrl: environment.attributes?.callbackUrl ?? ''
});

export const woocommerceEnvsFormInitValues = (environments: Array<Environment<WoocommerceEnvironmentAttributes>>): EnvironmentsFormFields<WoocommerceEnvironmentFormFields> => {
  const productionEnv = findEnvironmentByType(EnvironmentType.PRODUCTION, environments);
  const sandboxEnv = findEnvironmentByType(EnvironmentType.SANDBOX, environments);
  return {
    ...(productionEnv && {PRODUCTION: woocommerceEnvFormInitValues(productionEnv)}),
    ...(sandboxEnv && {SANDBOX: woocommerceEnvFormInitValues(sandboxEnv)})
  };
};

const woocommerceEnvFormValidationSchema = (t: TFunction): SchemaOf<WoocommerceEnvironmentFormFields> =>
  object().shape({
    ...envFormValidationSchema.fields,
    externalStatusPageEnabled: boolean()
      .required(t('SHARED.FIELD_REQUIRED')),
    callbackUrl: string()
      .required(t('SHARED.FIELD_REQUIRED'))
      .url('Provide valid URL')
  }).defined();

export const woocommerceEnvsFormValidationSchema = (t: TFunction): SchemaOf<EnvironmentsFormFields<WoocommerceEnvironmentFormFields>> =>
  object().shape({
    PRODUCTION: woocommerceEnvFormValidationSchema(t),
    SANDBOX: woocommerceEnvFormValidationSchema(t)
  }).defined();
